import React from 'react';
import CementitiousRouter from './CementitiousRouter';

export default function CementitiousPage() {
  return <CementitiousRouter />;
}
